import script from "./ModelagemPrecos.vue?vue&type=script&setup=true&lang=js"
export * from "./ModelagemPrecos.vue?vue&type=script&setup=true&lang=js"

import "./ModelagemPrecos.vue?vue&type=style&index=0&id=6b753ed1&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b753ed1"]])

export default __exports__